// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Box, Grid, TextField, Checkbox, FormControlLabel, FormControl, InputLabel, Select, MenuItem, Button, Typography, Paper, } from '@mui/material';
// import { useAuth } from '../context/AuthContext';

// const ProGroupMaster = ({ mode, onPopupCancel, connectionString }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const path = `${connectionString}/api`;
//     const { id } = useParams();
//     const navigate = useNavigate();

//     const [GroupName, setGroupName] = useState('');
//     const [GroupCode, setGroupCode] = useState('');
//     const [IsPrimary, setIsPrimary] = useState(true);
//     const [UnderGRPOptions, setUnderGRPOptions] = useState([]);
//     const [selectedUnderGRPId, setSelectedUnderGRPId] = useState('');
//     const [type, setType] = useState(''); // <-- NEW STATE
//     const [formError, setFormError] = useState('');

//     // Safely extract values with fallbacks
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const userCategory = user?.UserCategory || null;
//     const fYear = getCurrentFYear();

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await fetch(`${path}/group/getDetails/${id}`);
//                 const data = await response.json();
//                 console.log(data);
//                 setGroupName(data.GroupName);
//                 setGroupCode(data.GroupCode);
//                 setSelectedUnderGRPId(data.UnderGRP);
//                 setIsPrimary(data.IsPrimary === 1);
//                 setType(data.Type); // <-- Load saved type if available
//             } catch (error) {
//                 console.error('Error fetching group details:', error);
//             }
//         };

//         const fetchDropdownOptions = async () => {
//             try {
//                 const response = await fetch(`${path}/product-get-data/api/item-group?companyId=${companyId}`);
//                 const data = await response.json();
//                 const filtered = data.filter((item) => item.IsPrimary === 1);
//                 setUnderGRPOptions(filtered);
//             } catch (error) {
//                 console.error('Error fetching dropdown options:', error);
//             }
//         };

//         if (mode === 'edit') {
//             fetchData();
//         }
//         fetchDropdownOptions();
//     }, [id, mode]);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setFormError('');

//         if (!IsPrimary && (!selectedUnderGRPId || selectedUnderGRPId.toString().trim() === '')) {
//             setFormError('Under Group is required when "Is Primary" is unchecked.');
//             return;
//         }

//         const payload = { IsPrimary, GroupName, GroupCode, Type: type };
//         if (!IsPrimary) payload.UnderGRPId = selectedUnderGRPId;

//         console.log(payload);

//         try {
//             if (mode === 'add') {
//                 await axios.post(`${path}/group/Insert`, { payload, companyId, fYear, addUserId: userId, });
//                 setGroupName('');
//                 setGroupCode('');
//                 setIsPrimary(false);
//                 setSelectedUnderGRPId('');
//                 setType(''); // reset
//                 alert('Data inserted successfully');
//                 if (onPopupCancel) {
//                     onPopupCancel(); // Close dialog + refresh dropdown
//                 } else {
//                     navigate(-1); // Standalone page case
//                 }
//             } else {
//                 await axios.put(`${path}/group/Update/${id}`, { ...payload, companyId, fYear, editUserId: userId, });
//                 alert('Data updated successfully');
//                 navigate(-1);
//             }
//         } catch (error) {
//             console.error('Submission error:', error);
//             alert(`Error ${mode === 'add' ? 'inserting' : 'updating'} data`);
//         }
//     };

//     const handleCancel = () => {
//         if (onPopupCancel) {
//             onPopupCancel();
//         } else {
//             setGroupName('');
//             setGroupCode('');
//             setIsPrimary(false);
//             setSelectedUnderGRPId('');
//             setFormError('');
//             setType('');
//             navigate(-1);
//         }
//     };

//     return (
//         <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto', mt: 4 }}>
//             <form onSubmit={handleSubmit}>
//                 <Grid container spacing={2}>
//                     {/* Is Primary Checkbox */}
//                     <Grid item size={{ xs: 12 }}>
//                         <FormControlLabel label="Is Primary"
//                             control={
//                                 <Checkbox checked={IsPrimary}
//                                     onChange={(e) => {
//                                         const checked = e.target.checked;
//                                         setIsPrimary(checked);
//                                         if (checked) {
//                                             setSelectedUnderGRPId('');
//                                             setFormError('');
//                                         }
//                                     }}
//                                 />
//                             }
//                         />
//                     </Grid>

//                     {/* Group Name */}
//                     <Grid item size={{ xs: 12 }}>
//                         <TextField fullWidth label="Group Name" value={GroupName} onChange={(e) => setGroupName(e.target.value)} inputProps={{ maxLength: 25 }} required size='small' sx={{ '& .MuiInputBase-root': { height: 40 } }} />
//                     </Grid>

//                     {/* Group Code */}
//                     <Grid size={{ xs: 12 }}>
//                         <TextField fullWidth label="Group Code" value={GroupCode} onChange={(e) => setGroupCode(e.target.value)} required size='small' sx={{ '& .MuiInputBase-root': { height: 40 } }} />
//                     </Grid>

//                     {/* Under Group Dropdown */}
//                     <Grid item size={{ xs: 12 }}>
//                         <FormControl fullWidth disabled={IsPrimary} size='small' sx={{ '& .MuiInputBase-root': { height: 40 } }} error={!IsPrimary && !selectedUnderGRPId && formError !== ''}>
//                             <InputLabel>Under Group</InputLabel>
//                             <Select value={selectedUnderGRPId} onChange={(e) => setSelectedUnderGRPId(e.target.value)} label="Under Group" >
//                                 <MenuItem value="" disabled>Select an option</MenuItem>
//                                 {UnderGRPOptions.map((option) => (
//                                     <MenuItem key={option.ProdGRPID} value={option.ProdGRPID}>
//                                         {option.GroupName}
//                                     </MenuItem>
//                                 ))}
//                             </Select>
//                             {
//                                 !IsPrimary && !selectedUnderGRPId && formError &&
//                                 <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
//                                     {formError}
//                                 </Typography>
//                             }
//                         </FormControl>
//                     </Grid>

//                     {/* Type Dropdown (NEW FIELD) */}
//                     <Grid item size={{ xs: 12 }}>
//                         <FormControl fullWidth sx={{ mb: 2 }} size="small">
//                             <InputLabel>Behaviour Type</InputLabel>
//                             <Select value={type} label="Type" onChange={(e) => setType(e.target.value)} >
//                                 <MenuItem value="Finished Goods">Finished Goods</MenuItem>
//                                 <MenuItem value="Assembly">Assembly</MenuItem>
//                                 <MenuItem value="Sub-Assembly">Sub-Assembly</MenuItem>
//                                 <MenuItem value="Processing Materials">Processing Materials</MenuItem>
//                             </Select>
//                         </FormControl>
//                     </Grid>

//                     {/* Error Message */}
//                     {formError && (
//                         <Grid item size={{ xs: 12 }}>
//                             <Typography color="error" align="center">{formError}</Typography>
//                         </Grid>
//                     )}

//                     {/* Buttons */}
//                     <Grid item size={{ xs: 12 }} display="flex" justifyContent="center" gap={2}>
//                         <Button type="submit" variant="contained" color="primary" sx={{ minWidth: 120, height: 40 }}>
//                             {mode === 'add' ? 'Save' : 'Update'}
//                         </Button>
//                         <Button type="button" variant="contained" color="error" sx={{ minWidth: 120, height: 40 }} onClick={handleCancel}>
//                             Cancel
//                         </Button>
//                     </Grid>
//                 </Grid>
//             </form>
//         </Paper>
//     );
// };

// export default ProGroupMaster;

import { gradients } from '../utils/theme';
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Grid, TextField, Checkbox, FormControlLabel, FormControl, InputLabel, Select, MenuItem, Button, Typography, Snackbar, Alert, Divider } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { toProperCase } from '../utils/formatRows';
import { getCurrentFYear } from '../utils/financialYear';

// const ProGroupMaster = ({ mode, onPopupCancel, connectionString }) => {
//     const { user, selectedCompany, loading } = useAuth();

const ProGroupMaster = ({ mode, onPopupCancel, onSaved, connectionString, initialGroupName, user: propsUser, selectedCompany: propsSelectedCompany, id: propId }) => {
    const { user: authUser, selectedCompany: authSelectedCompany } = useAuth();
    const user = propsUser || authUser;
    const selectedCompany = propsSelectedCompany || authSelectedCompany;
    const path = `${connectionString}/api`;
    // const { id } = useParams();
    const id = propId;
    const navigate = useNavigate();

    const [GroupName, setGroupName] = useState('');
    const [GroupCode, setGroupCode] = useState('');
    const [IsPrimary, setIsPrimary] = useState(true);
    const [UnderGRPOptions, setUnderGRPOptions] = useState([]);
    const [selectedUnderGRPId, setSelectedUnderGRPId] = useState('');
    const [type, setType] = useState('');
    const [formError, setFormError] = useState('');
    const [isLoading, setIsLoading] = useState(false); // <-- NEW: Loading state
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    // Safely extract values with fallbacks
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const AppRegID = selectedCompany?.AppRegID || null;
    const userCategory = user?.UserCategory || null;
    const fYear = getCurrentFYear();

    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${path}/group/getDetails/${id}`);
                const data = await response.json();
                console.log(data);
                setGroupName(data.GroupName);
                setGroupCode(data.GroupCode);
                // <-- CHANGED: Only set selectedUnderGRPId if IsPrimary is 0
                if (data.IsPrimary === 0) {
                    setSelectedUnderGRPId(data.UnderGRP);
                }
                setIsPrimary(data.IsPrimary === 1);
                setType(data.Type);
            } catch (error) {
                console.error('Error fetching group details:', error);
            }
        };

        const fetchDropdownOptions = async () => {
            try {
                const response = await fetch(`${path}/product-get-data/api/item-group?companyId=${companyId}`);
                const data = await response.json();
                // <-- CHANGED: Filter to show only primary groups for dropdown
                const filtered = data.filter((item) => item.IsPrimary === 1);
                setUnderGRPOptions(filtered);
            } catch (error) {
                console.error('Error fetching dropdown options:', error);
            }
        };

        if (mode === 'edit') {
            fetchData();
        }
        if (companyId) {
            fetchDropdownOptions();
        }
    }, [id, mode, companyId]);

    useEffect(() => {
        if (mode === 'add' && initialGroupName) {
            console.log('Pre-filling GroupName with:', initialGroupName);
            setGroupName(initialGroupName);
        }
    }, [mode, initialGroupName]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError('');

        // <-- CHANGED: Validation only required when IsPrimary is false
        if (!IsPrimary && (!selectedUnderGRPId || selectedUnderGRPId.toString().trim() === '')) {
            setFormError('Under Group is required when "Is Primary" is unchecked.');
            return;
        }

        // <-- CHANGED: Build payload based on IsPrimary
        const payload = { IsPrimary, GroupName, GroupCode, Type: type };
        if (!IsPrimary) {
            payload.UnderGRPId = selectedUnderGRPId;
        }

        console.log('Payload being sent:', payload);

        try {
            setIsLoading(true);
            if (mode === 'add') {
                const response = await axios.post(`${path}/group/Insert`, { payload, companyId,AppRegID,fYear, addUserId: userId, });
                console.log('Insert response:', response.data);

                setGroupName('');
                setGroupCode('');
                setIsPrimary(true); // <-- CHANGED: Reset to true
                setSelectedUnderGRPId('');
                setType('');
                // if (onPopupCancel) {
                //     onPopupCancel({ created: true, groupName: GroupName });
                // } else {
                //     navigate(-1);
                // }

                if (typeof onSaved === "function") {
                    onSaved();
                }
                if (onPopupCancel) {
                    onPopupCancel({ created: true, groupName: GroupName });
                } else {
                    setSnackbar({ open: true, message: "Data inserted successfully", severity: 'success' })
                    setTimeout(() => { navigate(-1); }, 600);
                }
                return;
            } else {
                const response = await axios.put(`${path}/group/Update/${id}`, { ...payload, companyId,AppRegID, fYear, editUserId: userId, });
                console.log('Update response:', response.data);
                if (typeof onSaved === "function") {
                    onSaved();
                }
                if (onPopupCancel) {
                    onPopupCancel();
                } else {
                    setSnackbar({ open: true, message: "Data updated successfully", severity: 'success' })
                    setTimeout(() => { navigate(-1); }, 600);
                }
                return;
            }
        } catch (error) {
            console.error('Submission error:', error);
            const errorMessage = error.response?.data?.message || `Error ${mode === 'add' ? 'inserting' : 'updating'} data`;
            setSnackbar({ open: true, message: errorMessage, severity: 'error' });
            setFormError(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        if (onPopupCancel) {
            onPopupCancel();
        } else {
            setGroupName('');
            setGroupCode('');
            setIsPrimary(true); // <-- CHANGED: Reset to true
            setSelectedUnderGRPId('');
            setFormError('');
            setType('');
            navigate(-1);
        }
    };

    // ──────────────── Alt+S (Save/Update) & Alt+C (Cancel) shortcuts ────────────────
    // Attached to document in the capture phase so it fires regardless of which
    // field/dropdown currently has focus, including MUI popper/portal content.
    // Uses e.code (physical key position) instead of e.key so this also works on
    // macOS, where Option+letter often produces an accented/dead-key character
    // via e.key (e.g. Option+C → "ç") instead of the plain letter.
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            if (!e.altKey) return;

            if (e.code === "KeyS") {
                e.preventDefault();
                handleSubmit(e);
            } else if (e.code === "KeyC") {
                e.preventDefault();
                handleCancel();
            }
        };

        document.addEventListener("keydown", handleGlobalKeyDown, true);
        return () => document.removeEventListener("keydown", handleGlobalKeyDown, true);
    });

    const handleIsPrimaryChange = (checked) => {
        setIsPrimary(checked);
        if (checked) {
            // <-- CHANGED: Clear UnderGRP selection when changing to Primary
            setSelectedUnderGRPId('');
            setFormError('');
        }
    };

    return (
        <>
            <Box sx={{ height: 4, background: gradients.primaryRow }} />
            <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                    {mode === "add" ? "Add New Group" : "Edit Group"}
                </Typography>
            </Box>
            <Divider />
            <form onSubmit={handleSubmit} noValidate>
                <Box sx={{ px: 2.5, pt: 2, pb: 0.5 }}>
                <Grid container spacing={2}>
                    {/* Is Primary Checkbox */}
                    <Grid item size={{ xs: 12 }}>
                        <FormControlLabel label="Is Primary" control={ <Checkbox checked={IsPrimary} onChange={(e) => handleIsPrimaryChange(e.target.checked)} disabled={isLoading} /> } />
                    </Grid>

                    {/* Group Name */}
                    <Grid item size={{ xs: 12 }}>
                        <TextField fullWidth label="Group Name" value={toProperCase(GroupName)} onChange={(e) => setGroupName(toProperCase(e.target.value))} inputProps={{ maxLength: 25 }} required size='small' disabled={isLoading} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                    </Grid>

                    {/* Group Code */}
                    <Grid size={{ xs: 12 }}>
                        <TextField fullWidth label="Group Code" value={GroupCode} onChange={(e) => setGroupCode(e.target.value)} required size='small' disabled={isLoading} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                    </Grid>

                    {/* Under Group Dropdown - Only show when IsPrimary is false */}
                    {!IsPrimary && (
                        <Grid item size={{ xs: 12 }}>
                            <FormControl fullWidth disabled={IsPrimary || isLoading} size='small' required error={!IsPrimary && !selectedUnderGRPId && formError !== ''} sx={{ width: "100%", '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} >
                                <InputLabel required sx={{ '& .MuiFormLabel-asterisk': { color: 'red',}, }}>Under Group</InputLabel>
                                <Select value={selectedUnderGRPId} onChange={(e) => setSelectedUnderGRPId(e.target.value)} label="Under Group" >
                                    <MenuItem value="" disabled>Select an option</MenuItem>
                                    {UnderGRPOptions.map((option) => (
                                        <MenuItem key={option.ProdGRPID} value={option.ProdGRPID}>
                                            {option.GroupName}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {
                                    !IsPrimary && !selectedUnderGRPId && formError &&
                                    <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                        {formError}
                                    </Typography>
                                }
                            </FormControl>
                        </Grid>
                    )}

                    {/* Type Dropdown */}
                    <Grid item size={{ xs: 12 }}>
                        <FormControl size="small" disabled={isLoading} sx={{ mb: 2, width: "100%", '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}>
                            <InputLabel>Behaviour Type</InputLabel>
                            <Select value={type} label="Type" onChange={(e) => setType(e.target.value)} >
                                <MenuItem value="">Select Type</MenuItem>
                                <MenuItem value="Finished Goods">Finished Goods</MenuItem>
                                <MenuItem value="Assembly">Assembly</MenuItem>
                                <MenuItem value="Sub-Assembly">Sub-Assembly</MenuItem>
                                <MenuItem value="Processing Materials">Processing Materials</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Error Message */}
                    {formError && (
                        <Grid item size={{ xs: 12 }}>
                            <Typography color="error" align="center">{formError}</Typography>
                        </Grid>
                    )}

                </Grid>
                </Box>
                <Divider sx={{ mt: 1.5 }} />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button type="button" variant="outlined" color="inherit" size="small" onClick={handleCancel} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="contained" size="small" disabled={isLoading}>
                        {isLoading ? 'Processing...' : (mode === 'add' ? 'Save' : 'Update')}
                    </Button>
                </Box>
            </form>
            <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert severity={snackbar.severity} variant="filled">{snackbar.message}</Alert>
            </Snackbar>
        </>
    );
};

export default ProGroupMaster;